import { createSelector } from '@reduxjs/toolkit';

export const nutritionistSelector = createSelector(
  [state => state.nutritionist.data],
  nutritionist => nutritionist,
);
